'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ApplicationRenderer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _i18next = require('i18next');

var _i18next2 = _interopRequireDefault(_i18next);

var _reactI18next = require('react-i18next');

var _prax = require('prax');

var _ApplicationContextProviderComponent = require('./ApplicationContextProviderComponent');

var _ApplicationContextProviderComponent2 = _interopRequireDefault(_ApplicationContextProviderComponent);

var _NotificationView = require('./notification/NotificationView');

var _NotificationView2 = _interopRequireDefault(_NotificationView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ApplicationRenderer = exports.ApplicationRenderer = function (_PraxComponent) {
    _inherits(ApplicationRenderer, _PraxComponent);

    function ApplicationRenderer() {
        _classCallCheck(this, ApplicationRenderer);

        return _possibleConstructorReturn(this, (ApplicationRenderer.__proto__ || Object.getPrototypeOf(ApplicationRenderer)).apply(this, arguments));
    }

    _createClass(ApplicationRenderer, [{
        key: 'subrender',
        value: function subrender(_ref) {
            var deref = _ref.deref;
            var _props = this.props,
                _props$LoaderView = _props.LoaderView,
                LoaderView = _props$LoaderView === undefined ? DefaultLoaderView : _props$LoaderView,
                _props$ErrorView = _props.ErrorView,
                ErrorView = _props$ErrorView === undefined ? DefaultErrorView : _props$ErrorView,
                application = _props.application,
                children = _props.children;

            var _deref = deref(application.readiness),
                ready = _deref.ready,
                error = _deref.error;

            var authorization = application.authorization;


            return _react2.default.createElement(
                _ApplicationContextProviderComponent2.default,
                { application: application },
                !ready ? _react2.default.createElement(LoaderView, null) : _react2.default.createElement(
                    _reactI18next.I18nextProvider,
                    { i18n: _i18next2.default },
                    error ? _react2.default.createElement(ErrorView, { error: error }) : _react2.default.createElement(
                        'div',
                        { className: 'ut-app-' + application.appName },
                        typeof authorization.getAuthenticationComponent === 'function' ? authorization.getAuthenticationComponent() : null,
                        children,
                        _react2.default.createElement(_NotificationView2.default, null)
                    )
                )
            );
        }
    }]);

    return ApplicationRenderer;
}(_prax.PraxComponent);

function DefaultLoaderView() {
    return _react2.default.createElement(
        'span',
        null,
        'Loading...'
    );
}

function DefaultErrorView(_ref2) {
    var error = _ref2.error;

    if (!error) return null;
    return error.content || _react2.default.createElement(
        'div',
        null,
        'Application can\'t be started! ',
        _react2.default.createElement(
            'div',
            null,
            'Reason: ',
            error.message
        ),
        _react2.default.createElement(
            'pre',
            null,
            error.stack
        )
    );
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/applicationRenderer.js
// module id = 1313
// module chunks = 118